document.addEventListener("DOMContentLoaded", function () {
  const widthFeet = localStorage.getItem("WidthFeet");
  const widthInches = localStorage.getItem("WidthInches");
  const lengthFeet = localStorage.getItem("LengthFeet");
  const lengthInches = localStorage.getItem("LengthInches");

  const isAnyValuePresent =
    widthFeet || widthInches || lengthFeet || lengthInches;

  if (isAnyValuePresent) {
    setTimeout(() => {
      const rectangleBtn = document.querySelector("#CustomRugshape-rectangle");
      const squareBtn = document.querySelector("#CustomRugshape-square");
      if (squareBtn) {
        squareBtn.click();
      }
      if (rectangleBtn) {
        rectangleBtn.click();
      } else {
        return;
      }

      const widthFeetInput = document.querySelector(
        'input[name="properties[width-feet]"]'
      );
      const widthInchesInput = document.querySelector(
        'input[name="properties[width-inches]"]'
      );
      const lengthFeetInput = document.querySelector(
        'input[name="properties[length-feet]"]'
      );
      const lengthInchesInput = document.querySelector(
        'input[name="properties[length-inches]"]'
      );

      // Helper function to set the input value and dispatch a 'change' event
      function setInputValueAndDispatchEvent(inputElement, value) {
        if (inputElement && value !== null) {
          inputElement.value = value;
          const event = new Event("change", { bubbles: true });
          inputElement.dispatchEvent(event);
        }
      }

      setInputValueAndDispatchEvent(widthFeetInput, widthFeet);
      setInputValueAndDispatchEvent(widthInchesInput, widthInches);
      setInputValueAndDispatchEvent(lengthFeetInput, lengthFeet);
      setInputValueAndDispatchEvent(lengthInchesInput, lengthInches);

      // Your existing Cylindo element hiding logic
      const element = document.querySelector(
        '[cylindo-variant-selector="Size"]'
      );
      setTimeout(() => {
        if (element) {
          element.querySelector(".cylindoVariant__options").style.overflow =
            "hidden";
          element.querySelector(".cylindoVariant__options").style.height = "0";
        }
      }, 100);
    }, 500);
  }
});

// Accessiblility Js
document.querySelectorAll(".nav__menuItem").forEach((item) => {
  const link = item.querySelector(".nav__link");

  item.addEventListener("mouseenter", () => {
    link.setAttribute("aria-expanded", "true");
  });

  item.addEventListener("mouseleave", () => {
    link.setAttribute("aria-expanded", "false");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var el = document.getElementById("shopify-section-footer");
  if (el) el.setAttribute("role", "contentinfo");
});
function updateSlideVisibility() { 
  document.querySelectorAll('.swiper-slide').forEach(slide => {
    const variant = slide.querySelector('.cylindoVariant__option');
    if (variant) { 
      const availability = variant.getAttribute('data-availability');
      if (availability === 'false') {
        slide.style.display = 'none';
      } else {
        slide.style.display = '';
      }
    }
  });
}
setTimeout(updateSlideVisibility, 1000);

const observer_mutation = new MutationObserver(mutations => {
  for (const mutation of mutations) {
    if (
      mutation.type === 'attributes' &&
      mutation.attributeName === 'data-availability'
    ) {
      updateSlideVisibility();
      break;
    }
  }
});

function observeVariants() {
  document.querySelectorAll('.cylindoVariant__option').forEach(variant => {
    observer_mutation.observe(variant, { attributes: true });
  });
}
setTimeout(observeVariants, 1000);

// sub-category on collection page
   
document.addEventListener("DOMContentLoaded", function() {
const wrappers = document.querySelectorAll(".sub-category-menu-wrapper");
if (!wrappers.length) return; 

wrappers.forEach((wrapper) => {
const scroller = wrapper.querySelector(".sub-category-menu");
const btnLeft = wrapper.querySelector(".sub-cat-arrow--left");
const btnRight = wrapper.querySelector(".sub-cat-arrow--right");
if (!scroller || !btnLeft || !btnRight) return; 


const getScrollStep = () => Math.floor(scroller.clientWidth * 0.8);

const updateArrows = () => {
const maxScroll = scroller.scrollWidth - scroller.clientWidth;
const atStart = scroller.scrollLeft <= 2;
const atEnd = scroller.scrollLeft >= maxScroll - 2;

btnLeft.setAttribute("aria-hidden", atStart);
btnRight.setAttribute("aria-hidden", atEnd);
btnLeft.disabled = atStart;
btnRight.disabled = atEnd;


if (scroller.scrollWidth <= scroller.clientWidth + 1) {
  btnLeft.setAttribute("aria-hidden", "true");
  btnRight.setAttribute("aria-hidden", "true");
  btnLeft.disabled = true;
  btnRight.disabled = true;
}
};

const scrollByStep = (dir) => {
scroller.scrollBy({ left: getScrollStep() * dir, behavior: "smooth" });

clearTimeout(scroller._scrollTimeout);
scroller._scrollTimeout = setTimeout(updateArrows, 250);
};


btnLeft.addEventListener("click", () => scrollByStep(-1));
btnRight.addEventListener("click", () => scrollByStep(1));


let ticking = false;
scroller.addEventListener("scroll", () => {
if (!ticking) {
  requestAnimationFrame(() => {
    updateArrows();
    ticking = false;
  });
  ticking = true;
}
}, { passive: true });


window.addEventListener("resize", () => {
clearTimeout(scroller._resizeTimeout);
scroller._resizeTimeout = setTimeout(updateArrows, 150);
});


scroller.addEventListener("focusin", (e) => {
const el = e.target;
if (!el || !scroller.contains(el)) return;
const left = el.offsetLeft;
const right = left + el.offsetWidth;
if (left < scroller.scrollLeft) {
  scroller.scrollTo({ left: left - 12, behavior: "smooth" });
} else if (right > scroller.scrollLeft + scroller.clientWidth) {
  scroller.scrollTo({ left: right - scroller.clientWidth + 12, behavior: "smooth" });
}
});

scroller.scrollLeft = 0;
setTimeout(updateArrows, 80);
});
});

// end sub-category